;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputCheckboxListController', InputCheckboxListController)

  /* @ngInject */
  function InputCheckboxListController ($scope, Utils) {
    const api = {
      _checkForLinks
    }
    this.getApi = () => api

    activate()

    function activate () {
      api._checkForLinks()
    }

    $scope.showOnlyCheckedOptions = false

    if ($scope.enableHideUnchecked) {
      $scope.showOnlyCheckedOptions = true
    }

    $scope.isChecked = (value) => {
      return $scope.model && $scope.model.includes(value)
    }

    $scope.toggleShowCheckedOptions = function () {
      if (!$scope.enableHideUnchecked) {
        return
      }

      $scope.showOnlyCheckedOptions = !$scope.showOnlyCheckedOptions
    }

    $scope.onChange = function (newValue) {
      if (!$scope.model) {
        $scope.model = []
      }
      if ($scope.model.includes(newValue)) {
        const index = $scope.model.findIndex(value => value === newValue)
        $scope.model.splice(index, 1)
      } else {
        $scope.model.push(newValue)
      }

      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }
  }
})()
